import { render } from "./AvatarCircle.vue?vue&type=template&id=04213d42&scoped=true&ts=true"
import script from "./AvatarCircle.vue?vue&type=script&lang=ts"
export * from "./AvatarCircle.vue?vue&type=script&lang=ts"

import "./AvatarCircle.vue?vue&type=style&index=0&id=04213d42&lang=scss&scoped=true"

import exportComponent from "/builds/digitalsign/frontendweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04213d42"]])

export default __exports__